import type { TPublisherRequest } from '@modules/types'

import type { TSongUpdateData } from '../../../types'

export type { TSongUpdateData }

export type TDraftReviewSong = {
  songId: number
  isApproved: boolean | null
  copyrightNotice?: string | null
  rejectReason?: string | null
  printIsCounterOffered?: boolean
  printCounterOfferFee?: number | null
  digitalIsCounterOffered?: boolean
  digitalCounterOfferFee?: number | null
}

export const getExistingDraftReview = (selectedRequest: TPublisherRequest | undefined) => {
  return selectedRequest?.draftReview
}

export const getExistingSongs = (selectedRequest: TPublisherRequest | undefined) => {
  return getExistingDraftReview(selectedRequest)?.songs || []
}

export const findExistingSongIndex = (songs: TDraftReviewSong[], songId: number) => {
  return songs.findIndex(s => s.songId === songId)
}

export const createUpdatedSongsArray = (
  existingSongs: TSongUpdateData[],
  songUpdateData: TSongUpdateData,
) => {
  const existingSongIndex = findExistingSongIndex(existingSongs, songUpdateData.songId)
  const updatedSongs = [...existingSongs]

  if (existingSongIndex >= 0) {
    updatedSongs[existingSongIndex] = {
      ...updatedSongs[existingSongIndex],
      ...songUpdateData,
    }
  } else {
    updatedSongs.push(songUpdateData)
  }

  return updatedSongs
}

export const getExistingSong = (
  selectedRequest: TPublisherRequest | undefined,
  songId: number,
): TDraftReviewSong | undefined => {
  const existingDraftReview = getExistingDraftReview(selectedRequest)
  const songs = (existingDraftReview?.songs as Array<{ songId: number }> | undefined) || []
  return songs.find(s => s.songId === songId) as TDraftReviewSong | undefined
}

export const getOriginalSong = (selectedRequest: TPublisherRequest | undefined, songId: number) => {
  return selectedRequest?.songs?.find(s => s.id === songId)
}
